import fetch                from '../../../utils/browser-fetch';
import busyActionFactory    from '../../../busy';
import { addError }         from '../../../errors-dux';
import Errors               from '../../../errors';
import { addSuccessString } from '../../../success-dux';
import SuccessString        from '../../../success';

/******************
 * Initial state
 */
const initialState = {
    passwordRequested: false,
    busy: false
};

/******************
 * Non-async action types
 */
export const BUSY_REQUEST_PASSWORD = 'BUSY_REQUEST_PASSWORD';


/*****
 * Reducer
 */
export default function forgotPasswordData( state = initialState, action ) {
    switch ( action.type ) {
        case BUSY_REQUEST_PASSWORD:
            return {
                ...state,
                busy: action.busy
            };
        default:
            return state;
    }
}


/******************
 * Action creators
 */

const busyRequestingPassword = busyActionFactory( BUSY_REQUEST_PASSWORD );
export function requestPassword( emailAddress, userName ) {
    const successMessage = 'forgotPassword.form.successMessage';
    return dispatch => {
        dispatch( busyRequestingPassword( true ) );

          const reqObj    =   {
              emailAddress,
              userName
          };
        return fetch( '/api/v1.0/forgotPassword', {
            method: 'post',
             body: reqObj

        } )
            .then( () => {
                dispatch( busyRequestingPassword( false ) );
                dispatch( addSuccessString( true, successMessage, SuccessString.SUCCESS_FORGOTPASSWORD_REQUESTPASSWORD ) );
            } )
            .catch( ( error ) => {
                dispatch( busyRequestingPassword( false ) );
                dispatch( addError( error, Errors.ERROR_FORGOTPASSWORD_REQUESTPASSWORD ) );
            } );
    };
}
